import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccount } from 'wagmi';

import { useGetAdminWalletQuery } from 'src/store/services/project.service';

import { OTCSalesSection } from '../components/OTCSalesSection';
import { OverviewSection } from '../components/OverviewSection';
import { ProjectSalesSection } from '../components/ProjectSalesSection';

export default function MasterAnalytics() {
  const { address } = useAccount();
  const navigate = useNavigate();
  const { data: adminWallet, isLoading: isLoadingAdminWallet } = useGetAdminWalletQuery(
    { address: address as string },
    { skip: !address },
  );

  const isCheckingAccess = !address || isLoadingAdminWallet;

  useEffect(() => {
    if (!isCheckingAccess) {
      if (!adminWallet) {
        navigate('/core-sale', { replace: true });
      }
    }
  }, [isCheckingAccess, adminWallet, navigate]);

  if (isCheckingAccess) {
    return (
      <Box minHeight={'100vh'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        padding: { xs: 2, md: 4 },
        minHeight: '100vh',
      }}>
      <Stack spacing={6}>
        {/* Page Title */}
        <Typography
          variant='h4'
          sx={{
            fontFamily: 'Gotham',
            fontWeight: 700,
            fontSize: { xs: '24px', md: '32px' },
            color: '#FFFFFF',
            textAlign: 'center',
            marginBottom: 2,
          }}>
          MASTER ANALYTICS DASHBOARD
        </Typography>

        {/* Overview Section */}
        <OverviewSection />

        {/* Project Sales Details Section */}
        <ProjectSalesSection />

        {/* Sales by BD Section */}
        {/* <SalesByBDSection /> */}

        {/* OTC Sales Section */}
        <OTCSalesSection />
      </Stack>
    </Box>
  );
}
